export const getCTCByName = ctcName => {
  return `
        SELECT 
            Structure__c,
            Tree_Strutcure__c
        FROM 
            Case_Tree_Configuration__c 
        WHERE 
            Name='${ctcName}'        
    `;
};
